export default __webpack_public_path__ + "static/media/dictionaryImg.2422c2c5.png";